import React, { useEffect } from "react";

import { useGeneralContext, useGetFarms, useGetPracticeCrops, useLocation, useTranslation } from "utils";

import { MainPage, PageSpin } from "components";

import { BeefFormFlow } from "pages/app/footprinting/components/formFlows/BeefFormFlow";
import { CropFormFlow } from "pages/app/footprinting/components/formFlows/CropFormFlow";
import { DairyFormFlow } from "pages/app/footprinting/components/formFlows/DairyFormFlow";
import { FarmFormFlow } from "pages/app/footprinting/components/formFlows/FarmFormFlow";
import { PigletFormFlow } from "pages/app/footprinting/components/formFlows/PigletFormFlow";
import { PorkFormFlow } from "pages/app/footprinting/components/formFlows/PorkFormFlow";

interface FormFlowNavigationState {
  year?: number;
  // TODO: make these a global type
  formType?: "beef" | "crop" | "farm" | "dairy" | "piglet" | "pork";
  cropId?: string;
}

const FormFlow = () => {
  const { t } = useTranslation(["footprinting"]);
  const location = useLocation();
  const { setNavigationCrumbs } = useGeneralContext();
  const { currentFarm, isLoading: isGetFarmsLoading } = useGetFarms();

  const farmId = currentFarm?.id;
  const { year, formType, cropId }: FormFlowNavigationState = location.state ?? {};

  const { data: allCrops } = useGetPracticeCrops({ enabled: formType === "crop" });

  const cropName = allCrops?.find((crop) => crop.id === cropId)?.name;

  useEffect(() => {
    if (!formType || !year) return;
    setNavigationCrumbs({
      crumbs: [
        { name: currentFarm?.name || t("modules:navigation.overview.farm"), replacedByFarmSwitch: true },
        { name: t("footprintingLandingPage.breadcrumb"), link: "footprinting", linkState: { state: { year } } },
        { name: t(`navigation.${formType}.navBarTitle`, { year, cropName }) },
      ],
    });
  }, [formType]); // eslint-disable-line react-hooks/exhaustive-deps

  if (isGetFarmsLoading || !farmId || !year) {
    return <PageSpin />;
  }

  return (
    <MainPage
      fullWidth
      pageName="footprintingFormFlow"
      navigationCrumbs={{
        crumbs: [
          { name: currentFarm?.name || t("modules:navigation.overview.farm"), replacedByFarmSwitch: true },
          { name: t("footprintingLandingPage.breadcrumb"), link: "footprinting", linkState: { state: { year } } },
          { name: t(`navigation.${formType}.navBarTitle`, { year, cropName }) },
        ],
      }}
    >
      {formType === "farm" ? <FarmFormFlow farmId={farmId} year={year} /> : null}
      {formType === "crop" && cropId ? <CropFormFlow cropId={cropId} farmId={farmId} year={year} /> : null}
      {formType === "beef" ? <BeefFormFlow farmId={farmId} year={year} /> : null}
      {formType === "dairy" ? <DairyFormFlow farmId={farmId} year={year} /> : null}
      {formType === "piglet" ? <PigletFormFlow farmId={farmId} year={year} /> : null}
      {formType === "pork" ? <PorkFormFlow farmId={farmId} year={year} /> : null}
    </MainPage>
  );
};

export default FormFlow;
